import { getEnvVariable } from "../../../modules/environmentalList";
import DefaultSettings from "../components/settings";
import { GetData } from "../helpers/requests";

export const handleGenerateApplicationInvoice = (fieldValues, params) => {
    let routeid1 = params.routeid1;
    let url = getEnvVariable('Payment') + `Invoice/GenerateInvoice/` + `${routeid1}`;
    GetData(url, '', true).then(resp => {
    if(resp)
    {
        if (DefaultSettings.getAlert() != null)
            DefaultSettings.getAlert().show('An invoice has been generated for this request.  Request approval is contingent upon payment status.', 'info');
    }
    else
    {
        DefaultSettings.getAlert().show('Invoice generation was unsuccessful. Please navigate to More Options > Billing and click the Generate icon to create the invoice.', 'info');
    }      
  });
}
